module.exports = __webpack_public_path__ + "img/comment.8ab0b3f8.svg";